import axios from 'axios';

const TOKEN_API_URL = process.env.REACT_APP_LOGIN_API || process.env.React_APP_LOGIN_API || '';

let cachedToken = null;
let pendingTokenPromise = null;

export const getClientUrlFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('clintUrl')) return params.get('clintUrl');
    if (params.get('clientUrl')) return params.get('clientUrl');
    if (params.get('clientURL')) return params.get('clientURL');

    const pathSegments = window.location.pathname.split('/').filter(Boolean);

    // Handle specific routes
    if (pathSegments[0]?.toLowerCase() === 'payroll' && pathSegments[1]?.toLowerCase() === 'filepreview' && pathSegments.length >= 3) {
        return pathSegments[2]; // /payroll/filepreview/:clintUrl/:authId/...
    }
    if (pathSegments[0]?.toLowerCase() === 'payroll-preference') {
        return null; // /Payroll-Preference/:authId/:menuId/:corpId
    }

    // Handle general routes like /labour/:clintUrl/:authId/:menuId/:corpId or /job-master/:clintUrl/...
    if (pathSegments.length >= 2) {
        return pathSegments[1];
    }
    return null;
};

export const getAuthIDFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('authID')) return params.get('authID');
    if (params.get('authId')) return params.get('authId');

    const pathSegments = window.location.pathname.toLowerCase().split('/').filter(Boolean);

    // Handle specific routes first
    if (pathSegments[0] === 'payroll' && pathSegments[1] === 'filepreview' && pathSegments.length >= 4) {
        return pathSegments[3]; // /payroll/filepreview/:clintUrl/:authId/...
    }
    if (pathSegments[0] === 'payroll-preference' && pathSegments.length >= 2) {
        return pathSegments[1];
    }

    // Handle general routes like /PayrollEntry/:clintUrl/:authId/...
    if (pathSegments.length >= 3) {
        return pathSegments[2];
    }

    return null;
};

export const getMenuIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('menuID')) return params.get('menuID');
    if (params.get('menuId')) return params.get('menuId');

    const pathSegments = window.location.pathname.split('/').filter(Boolean);

    // Handle specific routes
    if (pathSegments[0]?.toLowerCase() === 'payroll-preference' && pathSegments.length >= 3) {
        return pathSegments[2]; // /Payroll-Preference/:authId/:menuId/:corpId
    }

    // Route /TimeandAttendance-report/:clintUrl/:authId/:menuId/:corpId
    // or /TimeandAttendance/:clintUrl/:authId/:menuId/:corpId
    if (pathSegments.length >= 4) {
        return pathSegments[3];
    }
    return null;
};

export const getCorpIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('corpId')) return params.get('corpId');
    if (params.get('corpID')) return params.get('corpID');

    const pathSegments = window.location.pathname.split('/').filter(Boolean);

    // Handle specific routes
    if (pathSegments[0]?.toLowerCase() === 'payroll-preference' && pathSegments.length >= 4) {
        return pathSegments[3]; // /Payroll-Preference/:authId/:menuId/:corpId
    }

    // Route /TimeandAttendance-report/:clintUrl/:authId/:menuId/:corpId
    // or /TimeandAttendance/:clintUrl/:authId/:menuId/:corpId
    if (pathSegments.length >= 5) {
        return pathSegments[4];
    }
    return null;
};

export const getRouteParams = () => {
    const clintUrl = getClientUrlFromUrl();
    const authId = getAuthIDFromUrl();
    const menuId = getMenuIdFromUrl();
    const corpId = getCorpIdFromUrl();
    return { clintUrl, authId, menuId, corpId };
};

export const getToken = async () => {
    if (cachedToken) {
        return cachedToken;
    }
    if (pendingTokenPromise) {
        return pendingTokenPromise;
    }

    pendingTokenPromise = (async () => {
        try {
            const authID = getAuthIDFromUrl();
            if (!authID) {
                console.warn('No authID found in URL or query params.');
                return null;
            }

            const response = await axios.post(
                `${TOKEN_API_URL}/v1/OpenApiauth/ExchangeOAuth`,
                { token: authID }
            );

            if (response.data && response.data.token) {
                cachedToken = response.data;
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error exchanging authID for token:', error);
            return null;
        } finally {
            pendingTokenPromise = null;
        }
    })();

    return pendingTokenPromise;
};

export const handleSessionTimeout = async () => {
    cachedToken = null;
    window.parent.postMessage('sessionout', '*');
    await new Promise((resolve) => setTimeout(resolve, 500));
};